'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const BookingVolumeChart = dynamic(() => import('./BookingVolumeChart'), { ssr: false });
const RevenueTrendChart = dynamic(() => import('./RevenueTrendChart'), { ssr: false });
const ServicePopularityChart = dynamic(() => import('./ServicePopularityChart'), { ssr: false });

export default function AdminChartsRow() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-3 gap-6">
      <div className="xl:col-span-1">
        <BookingVolumeChart />
      </div>
      <div className="xl:col-span-1">
        <RevenueTrendChart />
      </div>
      <div className="xl:col-span-1">
        <ServicePopularityChart />
      </div>
    </div>
  );
}